import { render, staticRenderFns } from "./ModalComponent.vue?vue&type=template&id=29dd1d6c&"
import script from "./ModalComponent.vue?vue&type=script&lang=js&"
export * from "./ModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports